/**
 * Auto-generated by `pnpm generate-pictograms`. Do not edit directly.
 */
import { PictogramName } from '../pictogramNames.generated';

export const pictogramOptions: PictogramName[] = [
  'PictogramAiInnovation',
  'PictogramAccessToInformation',
  'PictogramAdvisory',
  'PictogramAffirmation',
  'PictogramAntiMoneyLaundering',
  'PictogramArVrWearables',
  'PictogramArtificialIntelligence',
  'PictogramAssetAndWealthManagement',
  'PictogramAtom',
  'PictogramAuditing',
  'PictogramAutomation',
  'PictogramBike',
  'PictogramBirthday',
  'PictogramBlockchain',
  'PictogramCableCar',
  'PictogramCalculatorTax',
  'PictogramCalendar',
  'PictogramCamera',
  'PictogramCap',
  'PictogramCar',
  'PictogramCargoShip',
  'PictogramCharity',
  'PictogramChemicals',
  'PictogramClimateChange',
  'PictogramCloud',
  'PictogramCo2',
  'PictogramCogs',
  'PictogramCollaboration',
  'PictogramCommunity',
  'PictogramCompass',
  'PictogramCompetition',
  'PictogramComputerChip',
  'PictogramConstruction',
  'PictogramConsumerGoods',
  'PictogramConsumerMarkets',
  'PictogramContinuingEducation',
  'PictogramCreditCards',
  'PictogramCryptoTransaction',
  'PictogramCryptoWallet',
  'PictogramCrypto',
  'PictogramCustomerJourney',
  'PictogramCyberSecurity',
  'PictogramCycle_arrows',
  'PictogramCycle',
  'PictogramDashboard',
  'PictogramDataAnalysis',
  'PictogramDatabaseCloud',
  'PictogramDatabase',
  'PictogramDefense',
  'PictogramDeliveryTruck',
  'PictogramDemandPlanning',
  'PictogramDevices',
  'PictogramDining',
  'PictogramDisability',
  'PictogramDocument',
  'PictogramDrone',
  'PictogramEBook',
  'PictogramEducation',
  'PictogramElectricStation',
  'PictogramElectricVehicle',
  'PictogramEmployee',
  'PictogramEnergyPlant',
  'PictogramEnergy',
  'PictogramEnvironmentRegeneration',
  'PictogramEsg',
  'PictogramFaceRecognition',
  'PictogramFamily',
  'PictogramFastFood',
  'PictogramFilm',
  'PictogramFinancialData',
  'PictogramFinancialInvoice',
  'PictogramFinancialServicesBank',
  'PictogramFinancialServicesBankingDollar',
  'PictogramFinancialServicesBankingEuro',
  'PictogramFinancialServicesBankingPound',
  'PictogramFinancialStatement',
  'PictogramFoodBeverage',
  'PictogramForklift',
  'PictogramFreightContainer',
  'PictogramFruits',
  'PictogramFullBattery',
  'PictogramGaming',
  'PictogramGasPetrolStation',
  'PictogramGovernmentPublicSector',
  'PictogramGraphicDesign',
  'PictogramGrowthEconomy',
  'PictogramHandshake',
  'PictogramHealthcare',
  'PictogramHearingAid',
  'PictogramHeat',
  'PictogramHospital',
  'PictogramHospitalityDining',
  'PictogramHourglass',
  'PictogramHouse',
  'PictogramHousingHospitalityCities',
  'PictogramIdea',
  'PictogramInclusionDiversity',
  'PictogramIndustrialMachine',
  'PictogramInformationTechnology',
  'PictogramInsurance',
  'PictogramInternet',
  'PictogramInventoryManagement',
  'PictogramInvestment',
  'PictogramJourney',
  'PictogramKayak',
  'PictogramLaboratoryDiagnosis',
  'PictogramLaptop',
  'PictogramLifeboat',
  'PictogramLocation',
  'PictogramLowBattery',
  'PictogramMagnifyingGlass',
  'PictogramMailDelivery',
  'PictogramMailMessage',
  'PictogramMaintenance',
  'PictogramMan',
  'PictogramManagedServices',
  'PictogramManagement',
  'PictogramManufacturing',
  'PictogramMarketing',
  'PictogramMaterialFlow',
  'PictogramMegatrendsDemographicShift',
  'PictogramMegatrendsFracturingWorld',
  'PictogramMegatrendsSocialInstability',
  'PictogramMegatrendsTechDisruption',
  'PictogramMessages',
  'PictogramMicrophone',
  'PictogramMotorcycle',
  'PictogramNetworking',
  'PictogramNewsReport',
  'PictogramNuclear',
  'PictogramOcean',
  'PictogramOilBarrel',
  'PictogramOilGas',
  'PictogramOnboarding',
  'PictogramOpModel',
  'PictogramOperatingExpense',
  'PictogramPeople',
  'PictogramPharmaceuticals',
  'PictogramPicture',
  'PictogramPieChart',
  'PictogramPlatform',
  'PictogramPowerCable',
  'PictogramPresenter',
  'PictogramPublicTransport_bus',
  'PictogramQualityCheck',
  'PictogramQualityRecognition',
  'PictogramQuestion',
  'PictogramRaft',
  'PictogramRealEstate',
  'PictogramRecycle',
  'PictogramRegulation',
  'PictogramRestaurant',
  'PictogramRisk',
  'PictogramRobot',
  'PictogramRobotics',
  'PictogramSailboat',
  'PictogramSatellite',
  'PictogramScale',
  'PictogramScooterConnected',
  'PictogramScooter',
  'PictogramSelfDriveCar',
  'PictogramShipmentTracking',
  'PictogramShoppingCartGear',
  'PictogramSimulation',
  'PictogramSkills',
  'PictogramSmartphone',
  'PictogramSoftware',
  'PictogramSolar',
  'PictogramSpeech',
  'PictogramSpeedboat',
  'PictogramStar',
  'PictogramStartupEntrepreneurial',
  'PictogramStopSign',
  'PictogramStrategy',
  'PictogramSupplyChain',
  'PictogramSustainability',
  'PictogramTalent',
  'PictogramTarget',
  'PictogramTaxi',
  'PictogramTechnologyDigital',
  'PictogramTechnologyMediaTelecom',
  'PictogramTechnology',
  'PictogramTelecom',
  'PictogramTelevision',
  'PictogramTime_clock',
  'PictogramToDoList',
  'PictogramToolsPlansDesign',
  'PictogramTrain',
  'PictogramTravel',
  'PictogramTruckConnected',
  'PictogramTruck',
  'PictogramTrust',
  'PictogramUtilitiesElectricity',
  'PictogramVideoCall',
  'PictogramVision',
  'PictogramWarehouse',
  'PictogramWater',
  'PictogramWealthDollar',
  'PictogramWealthEuro',
  'PictogramWealthPound',
  'PictogramWeather',
  'PictogramWellbeing',
  'PictogramWindFarm',
  'PictogramWoman',
  'PictogramWorkforce',
  'PictogramWorld',
  'PictogramWorldwideShipping',
];
